import {
  Maybe,
  MoneyV2,
} from "@shopify/hydrogen/dist/esnext/storefront-api-types";
import Price from "../Price";

export interface ProductPriceProps {
  compareAtPrice?: Maybe<Partial<MoneyV2>>;
  price?: Maybe<Partial<MoneyV2>>;
  quantity?: number;
}

const ProductPrice = ({
  compareAtPrice,
  price,
  quantity = 1,
}: ProductPriceProps) => (
  <>
    {compareAtPrice?.amount && compareAtPrice?.currencyCode && (
      <Price
        amount={parseFloat(compareAtPrice.amount) * quantity}
        currencyCode={compareAtPrice.currencyCode}
        hasCurrencyCode={false}
        style={{
          textDecoration: "line-through",
        }}
      />
    )}
    {price?.amount && price?.currencyCode && (
      <Price
        amount={parseFloat(price.amount) * quantity}
        currencyCode={price.currencyCode}
      />
    )}
  </>
);

export default ProductPrice;
